export default [
  {
    title: "User Management",
    icon: "ShieldIcon",
    children: [
      {
        title: "Users & Roles",
        route: "manage-users",
      },
      // {
      //   title: 'Permissions',
      //   route: 'permissions-list',
      // },
    ],
  },
];
